import {Exclude, Expose, Type} from 'class-transformer';

@Exclude()
export class InstagramMediaItemApiModel {
  @Expose() public instagramMediaId: string;
  @Expose() public mediaType: string;
  @Expose() public caption: string | null;
  @Expose() public permalink: string | null;
  @Expose() public mediaUrl: string | null;
  @Expose() public thumbnailUrl: string | null;
  @Expose() @Type(() => InstagramMediaItemApiModel) public children: InstagramMediaItemApiModel[] = [];
  @Expose() @Type(() => Date) public publishedAt: Date | null;
  @Expose() public selected: boolean;
}
